import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Img from './img';
const Lightbox = ({ images, index, alt = 'Preview', onClose, onPrev, onNext }) => {
    React.useEffect(() => {
        if (!images.length)
            return;
        const handler = (e) => {
            if (e.key === 'Escape')
                onClose();
            if (e.key === 'ArrowLeft')
                onPrev();
            if (e.key === 'ArrowRight')
                onNext();
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [images.length, onClose, onPrev, onNext]);
    const pointerStartX = React.useRef(null);
    const startedOnBackdrop = React.useRef(false);
    if (!images.length)
        return null;
    const current = images[index];
    const multi = images.length > 1;
    const handlePointerDown = (e) => {
        pointerStartX.current = e.clientX;
    };
    const handlePointerUp = (e) => {
        const startX = pointerStartX.current;
        pointerStartX.current = null;
        const deltaX = startX === null ? 0 : e.clientX - startX;
        if (multi && Math.abs(deltaX) > 50)
            (deltaX < 0 ? onNext : onPrev)();
    };
    return (_jsxs("div", { className: "file-preview-lightbox", onPointerDown: (e) => { startedOnBackdrop.current = e.target === e.currentTarget; }, onClick: (e) => startedOnBackdrop.current && e.target === e.currentTarget && onClose(), children: [_jsx("button", { type: "button", className: "file-preview-lightbox-close", onClick: onClose, "aria-label": "Close preview", children: _jsx("i", { className: "bi bi-x-lg" }) }), _jsxs("div", { className: "carousel slide file-preview-lightbox-carousel", style: { touchAction: 'none' }, onClick: (e) => e.stopPropagation(), onPointerDown: handlePointerDown, onPointerUp: handlePointerUp, children: [_jsx(Img, { src: current.url, alt: current.caption || alt, className: "d-block file-preview-lightbox-image", draggable: false }), multi && (_jsxs(_Fragment, { children: [_jsxs("button", { className: "carousel-control-prev", type: "button", onClick: onPrev, children: [_jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }), _jsx("span", { className: "visually-hidden", children: "Previous" })] }), _jsxs("button", { className: "carousel-control-next", type: "button", onClick: onNext, children: [_jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }), _jsx("span", { className: "visually-hidden", children: "Next" })] }), _jsxs("div", { className: "file-preview-lightbox-counter", children: [index + 1, " / ", images.length] })] })), current.caption && (_jsx("div", { className: "file-preview-lightbox-caption", children: current.caption }))] })] }));
};
export default Lightbox;
